export default __webpack_public_path__ + "static/media/inscription.b52524ca.webp";